type PermissionConstants = {
  [K in PermissionState as Uppercase<K>]: K;
};

export const PERMISSION_STATES: PermissionConstants = {
  GRANTED: 'granted',
  DENIED: 'denied',
  PROMPT: 'prompt',
};
